import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const shimmerStyle = {
  background: 'linear-gradient(90deg, #f0f2f7 25%, #e2e6ef 50%, #f0f2f7 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.4s infinite',
  borderRadius: '4px',
};

const DonutChart = ({ data, loading = false }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (loading || !data || !canvasRef.current) return;

    const existing = Chart.getChart(canvasRef.current);
    if (existing) existing.destroy();

    const chart = new Chart(canvasRef.current, {
      type: 'doughnut',
      data: data,
      options: {
        cutout: '62%',
        maintainAspectRatio: false,
        plugins: {
  legend: {
    position: 'right',
    labels: { font: { size: 11 }, boxWidth: 10, padding: 8 },
  },
  tooltip: {
    callbacks: {
      label: function(context) {
        return `${context.label}: $${context.raw}`;
      },
    },
  },
},
      },
    });

    return () => chart.destroy();
  }, [data, loading]);

  if (loading) {
    return (
      <div className="chart-wrap-sm" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '24px' }}>
        <div style={{ ...shimmerStyle, width: '120px', height: '120px', borderRadius: '50%' }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {[70, 50, 60, 40].map((w, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ ...shimmerStyle, width: '10px', height: '10px', borderRadius: '2px', flexShrink: 0 }} />
              <div style={{ ...shimmerStyle, width: `${w}px`, height: '10px' }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="chart-wrap-sm" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--muted)', fontSize: '12px' }}>
        No data available
      </div>
    );
  }

  return (
    <div className="chart-wrap-sm">
      <canvas ref={canvasRef}></canvas>
    </div>
  );
};

export default DonutChart;